import { render, staticRenderFns } from "./VSwitch.vue?vue&type=template&id=4536758b&scoped=true&"
import script from "./VSwitch.vue?vue&type=script&lang=ts&"
export * from "./VSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./VSwitch.vue?vue&type=style&index=0&id=4536758b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4536758b",
  null
  
)

export default component.exports